"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.regexp.to-string");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _statistics = require("@/api/statistics");
var _vuex = require("vuex");
var _default = exports.default = {
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      times: [],
      listLoading: false,
      dialogVisible: false,
      dialogType: 'new',
      list: [],
      appnameList: [],
      called: {},
      total: 0,
      listQuery: {
        startTime: '',
        endTime: '',
        appName: '',
        country_code: ''
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['brandList', 'roles'])),
  watch: {
    times: function times(val) {
      this.listQuery.startTime = '';
      this.listQuery.endTime = '';
      if (val) {
        this.listQuery.startTime = val[0];
        this.listQuery.endTime = val[1];
      }
    }
  },
  mounted: function mounted() {
    // this.getList()
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var appNames, _yield$regionList, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              appNames = this.listQuery.appName.toString();
              _context.n = 1;
              return (0, _statistics.regionList)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.listQuery), {}, {
                appName: appNames
              }));
            case 1:
              _yield$regionList = _context.v;
              code = _yield$regionList.code;
              data = _yield$regionList.data;
              this.listLoading = false;
              if (code === 0) {
                this.list = data;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    handleFilter: function () {
      var _handleFilter = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.listQuery.page = 1;
              this.getList();
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleFilter() {
        return _handleFilter.apply(this, arguments);
      }
      return handleFilter;
    }(),
    userExport: function userExport() {
      window.open("/api/xls/region/export?startTime=".concat(this.listQuery.startTime, "&endTime=").concat(this.listQuery.endTime, "&appName=").concat(this.listQuery.appName, "&country_code=").concat(this.listQuery.country_code, "&client_app_type=").concat(this.listQuery.client_app_type, "&roles=").concat(this.roles, "&username=").concat(this.name));
    }
  }
};